import { PhotoMetadata } from "./photos/PhotoMetadata";
import { OperationStatus } from "../OperationStatus.interface";
import { SubmitJob } from "./SubmitJob";
import { ReceivingItemRef } from "./ReceivingItemRef";
export class AddReceivingLogResponse {
    public constructor(init?: Partial<AddReceivingLogResponse>) {
        Object.assign(this, init);
        this.receivingLogStatus = new OperationStatus();
        this.receivingNoteStatus = new OperationStatus();
        this.photoUploadStatus = new OperationStatus();
        this.emailStatus = new OperationStatus();
        this.receiptLedgerStatus = new OperationStatus();
        this.poCompletionStatus = new OperationStatus();
        this.receivingItemsStatus = new OperationStatus();
        this.damagedAttachmentStatus = new OperationStatus();
        this.expeditingEmailStatus = new OperationStatus();
        this.receivingLogId = 0;
        this.receivingItems = [];
        this.receivingItemIds = [];
        this.quantityDisplay = '';
        this.uploadedPhotos = [];
        this.isSuccess = false;
    }
    receivingLogStatus: OperationStatus;
    receivingNoteStatus: OperationStatus;
    photoUploadStatus: OperationStatus;
    emailStatus: OperationStatus;
    /** Status of the new-ledger receipt rows write. Never fails the overall request. */
    receiptLedgerStatus: OperationStatus;
    /** Status of the PO-completion (`completesPo`) write. Never fails the overall request. */
    poCompletionStatus: OperationStatus;
    /** Status of the MM.ReceivingItems rows write. Never fails the overall request. */
    receivingItemsStatus: OperationStatus;
    /** Status of the per-item damage-photo attachment write. Never fails the overall request. */
    damagedAttachmentStatus: OperationStatus;
    /** Status of the separate expediting / missing-items email send. Never fails the overall request. */
    expeditingEmailStatus: OperationStatus;
    receivingLogId: number;
    /**
     * The MM.ReceivingItems rows created for this log — one per physical unit of
     * each `containerItems` pair, each with its GUID and the caption facts its
     * label prints ("BOX 2 of 3"). Empty when the backend didn't create item rows.
     * This is what the print payload is built from.
     */
    receivingItems: ReceivingItemRef[];
    /**
     * The same rows' GUIDs alone, retained for backward compatibility. Prefer
     * `receivingItems`: ids can't tell a box from a pallet, so they can't caption
     * a label on a mixed delivery.
     */
    receivingItemIds: string[];
    /**
     * The backend-derived quantity string ("3 BOX, 2 PALLET") that was persisted
     * onto the log. Display THIS rather than a locally composed one — the backend
     * overwrites whatever `receivingLogRow.quantity` the request carried.
     */
    quantityDisplay: string;
    uploadedPhotos: any[];
    isSuccess: boolean;

    /**
     * Async-submit outcome. `"Accepted"` (AsyncSubmit flag ON) means the core is
     * durably saved and the slow side-effects were enqueued as `jobs` (all Pending) —
     * the caller must resolve the final state by polling `…/status`. Undefined on the
     * synchronous path (flag OFF / older backend), where the per-step statuses above
     * are the final verdict; branch on this being `"Accepted"` to decide.
     */
    outcome?: string;

    /**
     * The background jobs enqueued for this submit (only on the `"Accepted"` path;
     * empty/undefined synchronously). All `Pending` at submit time.
     */
    jobs?: SubmitJob[];
}